import { chain, filter, get, orderBy } from 'lodash'
import server from '../../../server'
import { vsName as ServerUtilityName } from '../../../../records/server/serverUtility'
import { vsName as GridSettingsServiceName } from '../../../../records/grids/settings/gridSettingsService'
import { vsName as CsvWriterName } from '../../../../records/csv/csvWriter'

const blankPartPropertyOption = { Id: -1, Name: 'Display All', DisplayName: 'Display All' }

const trackedItemFilterOptions = [
  {
    value: '',
    name: '-- Tracked Item --'
  },
  {
    value: 'true',
    name: 'Tracked'
  },
  {
    value: 'false',
    name: 'Untracked'
  }
]

const defaultQuery = {
  Status: 'Active',
  Include: 'Locations,PartOrderItems',
  TrackedItem: ''
}

const defaultTrackedItem = trackedItemFilterOptions[0]

PartsMainGridController.$inject = [
  'PartsMainGridDataSource',
  '$state',
  'userProfile',
  'angularGridValueGetters',
  'angularGridTemplates',
  server.vsName,
  '$window',
  ServerUtilityName,
  '$q',
  GridSettingsServiceName,
  CsvWriterName
]
function PartsMainGridController(
  PartsMainGridDataSource,
  $state,
  userProfile,
  angularGridValueGetters,
  angularGridTemplates,
  partServer,
  $window,
  serverUtility,
  $q,
  gridSettingsService,
  csvWriter) {

  var vm = this
  vm.$onInit = $onInit
  vm.gridSettings = gridSettingsService.getGridSettings(Symbol('main.parts.main'))
  vm.download = download  

  let columnDefs = [
    {
      colId: 'detail',
      headerName: '',
      width: 20,
      template: angularGridTemplates.detailUrl('main.parts.part.locations({partId: data.Id})'),
      editable: false,
      suppressMenu: true,
      suppressSorting: true
    },
    { headerName: 'Part Number', field: 'PartNumber', editable: false, suppressMenu: true },
    { colId: 'PartManufacturerName', field: 'PartManufacturerName', headerName: 'Manufacturer', valueGetter: angularGridValueGetters.byPath('PartManufacturer.Name'), editable: false, suppressMenu: true },
    { headerName: 'Cabinet', field: 'CabinetType', editable: false, suppressMenu: true },
    { headerName: 'Description', field: 'PartDescription', editable: false, suppressMenu: true },
    { headerName: 'Locations', valueGetter: getPartLocations, editable: false, suppressMenu: true, suppressSorting: true },
    { headerName: 'Keyword', valueGetter: angularGridValueGetters.byPath('PartKeyword.Name'), editable: false, suppressMenu: true, suppressSorting: true },
    { headerName: 'Status', field: 'Status', editable: false, suppressMenu: true },
    { headerName: 'Quantity', valueGetter: getQuantity, editable: false, suppressMenu: true, suppressSorting: true },
    { headerName: 'Unit Price', field: 'UnitPrice', editable: false, suppressMenu: true },
    { headerName: 'Type', valueGetter: angularGridValueGetters.byPath('PartType.Name'), editable: false, suppressMenu: true, suppressSorting: true },
    { headerName: 'Last Order Cost', valueGetter: getLastOrderCost, editable: false, suppressMenu: true, suppressSorting: true },
    {
      colId: 'TrackedItem',
      headerName: 'Tracked?',
      field: 'TrackedItem',
      width: 65,
      editable: false,
      suppressMenu: true,
      suppressSorting: false,
      template: angularGridTemplates.toggleBox('ctrl.trackedItemClicked(data)', 'data.TrackedItem'),
      requiresPermission: 'partEdit'
    },
    {
      headerName: '',
      editable: false,
      width: 106,
      suppressMenu: true,
      suppressSorting: true,
      template: '<div class="btn btn-primary text-center" ng-click="ctrl.showLinkedParts(data)">Linked Parts</div>'
    },
    {
      colId: 'edit',
      headerName: '',
      width: 20,
      template: angularGridTemplates.edit('ctrl.editPart(data)'),
      editable: false,
      suppressMenu: true,
      suppressSorting: true,
      requiresPermission: 'partEdit'
    }
  ]

  columnDefs = filter(columnDefs, function (columnDef) {
    var permission = columnDef.requiresPermission
    return permission === undefined || userProfile.hasPermission(permission)
  })

  vm.gridOptions = {
    enableServerSideSorting: true,
    enableServerSideFilter: true,
    columnDefs: columnDefs,
    enableColResize: true,
    angularCompileRows: true,
    rowHeight: 40,
    rowSelection: 'multiple',
    ready: () => gridReady(),
    afterSortChanged: () => afterSortChanged()
  }


  function $onInit() {
    vm.parts = vm.parts || []
    vm.filterChanged = filterChanged
    vm.editPart = editPart
    vm.actionsEnabled = actionsEnabled
    vm.deselectAll = deselectAll
    vm.clearFilters = clearFilters
    vm.showLinkedParts = showLinkedParts
    vm.trackedItemClicked = trackedItemClicked
    vm.propertySelectionChanged = propertySelectionChanged

    vm.partProperties = [blankPartPropertyOption]
    vm.selectedPartProperty = blankPartPropertyOption
    vm.trackedItemFilterOptions = trackedItemFilterOptions
    vm.selectedTrackItemOption = trackedItemFilterOptions[0]

    initializeProperties()

    partServer.partPropertyQuery({
      Take: 100
    }).
      then(queryResult => {
        vm.partProperties.push(...queryResult.Results)
      })    
  }

  function gridReady() {
    vm.query = initializeGridQuery()
    const sort = vm.gridSettings.getSort()
    if(sort){
      vm.gridOptions.api.setSortModel(sort)
    }
    vm.gridOptions.api.setDatasource(new PartsMainGridDataSource(vm.query, vm.gridOptions))
  }

  function afterSortChanged(){
    vm.gridSettings.saveSort(vm.gridOptions.api.getSortModel())
  }

  function initializeGridQuery() {
    const query = vm.gridSettings.getQuery()
    const initialQuery = query ? query : { ...defaultQuery }

    if (initialQuery.PartPropertyId) {
      vm.selectedPartProperty = { Id: initialQuery.PartPropertyId }
    }
    if (initialQuery.TrackedItem !== undefined) {
      const selectedOption = trackedItemFilterOptions.filter(opt => opt.value === initialQuery.TrackedItem ||
        (opt.value === defaultTrackedItem.value && (initialQuery.TrackedItem === undefined || initialQuery.TrackedItem === null))
      )
      vm.selectedTrackItemOption = selectedOption[0]
    }

    return initialQuery
  }

  function filterChanged() {
    vm.query.PartPropertyId = vm.selectedPartProperty.Id < 1 ? null : vm.selectedPartProperty.Id
    vm.query.TrackedItem = vm.selectedTrackItemOption.value === defaultTrackedItem.value ? null : vm.selectedTrackItemOption.value
    vm.gridSettings.saveQuery(vm.query)
    vm.gridOptions.api.setDatasource(new PartsMainGridDataSource(vm.query, vm.gridOptions))
  }

  function editPart(part) {
    $state.go('^.part.edit', { partId: part.Id, part: part })
  }

  const actionValidators = {
    repair: function (parts) {
      return parts.length === 1
    }
  }

  function actionsEnabled(action) {
    if (action in actionValidators) {
      return actionValidators[action](vm.parts)
    }
    return vm.parts.length > 0
  }

  function deselectAll() {
    vm.parts = []
  }

  function clearFilters() {
    vm.query = {
      ...defaultQuery
    }
    vm.selectedPartProperty = blankPartPropertyOption
    vm.selectedTrackItemOption = defaultTrackedItem
    vm.selectedProperties = []
    filterChanged()
  }

  function getPartLocations(params) {
    const part = params.data
    const locations = part.Locations
    if (!locations || locations.length === 0) {
      return ''
    }

    const properties = locations.map(location => {
      return {
        property: location.PartProperty,
        shelf: location.Shelf,
        bin: location.Bin
      }
    })
    const distinctProperties = chain(properties)
      .filter((property) => property !== '')
      .uniq()
      .sortBy()
      .value()

    const separator = '<br />'
    let result = distinctProperties.reduce((accumulator, currentValue) => {
      return accumulator + getPartPropertyDisplayName(currentValue.property, vm.properties) + '(' + currentValue.shelf + '-' + currentValue.bin + ')' + separator
    }, '')

    result = result.substring(0, result.length - separator.length)
    //remove the leading comma
    return result
  }

  function getQuantity(params) {
    const locations = get(params, 'data.Locations', [])
    if (locations.length === 0) {
      return 0
    }

    return locations.reduce((accumulator, location) => accumulator + (location.Quantity || 0), 0)
  }

  function getLastOrderCost(params){
    const partOrderItems = get(params, 'data.PartOrderItems', [])
    const lastPartOrder = orderBy(partOrderItems, pi => pi.PartOrderOrderDate, 'desc').at(0) || {}
    return lastPartOrder.UnitCost
  }

  function showLinkedParts(part) {
    vm.query = {
      ...defaultQuery,
      PartGroupId: part.PartGroupId
    }
    filterChanged()
  }

  function trackedItemClicked(part) {
    partServer.partSetTrackedItem(part.Id, part.TrackedItem)
  }

  function propertySelectionChanged() {
    const properties = vm.selectedProperties
    const specificPropertiesRequested = properties.length > 0
    const propertyIds = properties.map(p => p.Id)
    vm.query.PropertyIds = propertyIds

    const partProperties = specificPropertiesRequested ? vm.partProperties.filter(pp => propertyIds.includes(pp.PropertyId)) : vm.partProperties
    vm.activePartProperties = [blankPartPropertyOption, ...orderBy(partProperties, pp => pp.DisplayName)]

    if (specificPropertiesRequested && !properties.find(p => p.Id === vm.selectedPartProperty.PropertyId)) {
      vm.query.PartPropertyId = undefined
      vm.selectedPartProperty = blankPartPropertyOption
    }

    vm.filterChanged()
  }

  function initializeProperties() {
    vm.partProperties = [blankPartPropertyOption]
    vm.selectedPartProperty = blankPartPropertyOption
    vm.selectedProperties = []

    const allPropertyPromise = serverUtility.fetchAll({
      url: "/api/properties",
      query: { OrderBy: "Name" }
    })

    const partPropertyPromise = partServer.partPropertyQuery({
      Take: 100
    })

    $q.all([allPropertyPromise, partPropertyPromise]).then(promiseValues => {
      const [allProperties, partPropertyQueryResults] = promiseValues

      const userProperties = vm.properties = allProperties
      const userPartProperties = vm.partProperties = partPropertyQueryResults.Results.map(pp => { return { ...pp, DisplayName: getPartPropertyDisplayName(pp, userProperties) } })

      const currentPartPropertyId = vm.query.PartPropertyId
      let currentPartProperty = userPartProperties.find(pp => pp.Id === currentPartPropertyId)
      if (currentPartProperty) {
        currentPartProperty =
          (userProperties.length === 0 || (userProperties.find(p => p.Id === currentPartProperty.PropertyId)))
            ? currentPartProperty
            : blankPartPropertyOption
      } else {
        currentPartProperty = blankPartPropertyOption
      }

      vm.selectedPartProperty = currentPartProperty

      const currentPropertyIds = vm.query.PropertyIds || []

      const selectedProperties = userProperties.filter(p => currentPropertyIds.includes(p.Id))
      vm.selectedProperties.push(...selectedProperties)

      vm.query.PartPropertyId = currentPartProperty ? currentPartProperty.Id : undefined
      const activePartProperties = currentPropertyIds.length > 0
        ? userPartProperties.filter(pp => currentPropertyIds.includes(pp.PropertyId))
        : [...userPartProperties]

      vm.activePartProperties = [blankPartPropertyOption, ...orderBy(activePartProperties, pp => pp.DisplayName)]
    })
  }

  function getPartPropertyDisplayName(partProperty, userProperties) {
    userProperties  = userProperties || []
    if (userProperties.length < 2) {
      return partProperty.Name
    }
    const property = userProperties.find(p => p.Id === partProperty.PropertyId)
    return `${property.Name}-${partProperty.Name}`
  }

  function download(){
    serverUtility.sendApiRequest({
      method: 'get',
      url: '/api/parts/download',
      params: vm.query
    }).then(r => {      
      csvWriter.saveFile({
        content: r,
        filename: "PartInventory.csv",
      })
    })
  }
}

export default PartsMainGridController